import {Injectable} from "@angular/core";
import {NestApiProvider} from "../nest-api";
import {Observable} from "rxjs";
// import { NestAuthProvider } from '../nest-auth';

@Injectable()
export class YesdokService {
  private _service: string = 'yesdok';
  private _model: string = 'yesdok';
  // private _accessToken = "?access_token="+ this.nestAuthProvider.getAccessToken();

  constructor(
    private nestApiProvider: NestApiProvider,
    // private nestAuthProvider: NestAuthProvider
  ) {

  }
  getYesdokUrl(body: any):Observable<any>{
    const _method: string = 'POST';
    const _func: string = 'yesdokRequest' //+ this._accessToken;
    const _params: any = body;
    const _urlParams: any = {};
    const _body: any = {}
    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, {}, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/yesdok/yesdok.api.ts